  <section></section>
  <section></section>
  <section class="pb-0">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="section-header">
            <h1 class="h1">{{translationScope + '.titles.course_request' | transloco}}</h1>
            <div class="col-12 col-md-8 p-0">
              <p class="p">
                {{translationScope + '.subtitles.course_request' | transloco}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="pt-0">
    <app-template-request-form
      [templates]="templates$ | async"
      [regions]="regions$ | async"
      [user]="user$ | async"
      (submitTemplateRequest)="requestCourse($event)"
    >

    </app-template-request-form>
  </section>
